export const isDOMReady = () =>
  !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );

export const modalRoot =
  isDOMReady() && window.document.getElementById('modal-container');
